export const DOT_COLORS = {
  DEFAULT: 'sage',
  CHARCOAL: 'charcoal',
  PURPLE: 'purple',
  SAGE: 'sage',
  YELLOW: 'yellow',
  ORANGE: 'orange',
  RED: 'red',
  GREY: 'grey',
};
